import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const CHAT_API = `${API}/chat`;

// dedicated client for chat — uses cookies + Bearer fallback
const chatApi = axios.create({
  baseURL: CHAT_API,
  withCredentials: true,
});

chatApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("vg_chat_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function chatWsUrl() {
  const token = localStorage.getItem("vg_chat_token");
  const wsBase = BACKEND_URL.replace(/^http/, "ws");
  const u = new URL(`${wsBase}/api/chat/ws`);
  if (token) u.searchParams.set("token", token);
  return u.toString();
}

export default chatApi;
